import ProjectView from "../project-view"
import ProjectViews from "../project-views"
import {ProjectViewAccess} from "../@const"

export type ProjectViewDuplicateParams = {
    name        : string
    access      : ProjectViewAccess
    isPinned?   : boolean
    template?   : any
    documentId? : ID
    url?        : string
}

export default async function projectView_duplicate(projectViews: ProjectViews, view:ProjectView, params: ProjectViewDuplicateParams) {
    const viewConfig = view.toJson()
    delete viewConfig.id
    viewConfig.name         = params.name
    viewConfig.access       = params.access

    if (params.documentId)  viewConfig.documentId   = params.documentId
    // if (params.url)         viewConfig.url          = params.url

    viewConfig.appSettings  = params.template ? {templateId: params.template.id} : _.omit(view.appSettings, ['inheritedFromProjectId'])

    delete viewConfig.sharedViewId // shared view id should not be copied

    const newView = await projectViews.createView(viewConfig)

    newView.open({isAutoOpen: true})
}